import { c as _c } from "react/compiler-runtime";
const ExclamationDisc = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M8,14.5 C4.41014913,14.5 1.5,11.5898509 1.5,8 C1.5,4.41014913 4.41014913,1.5 8,1.5 C11.5898509,1.5 14.5,4.41014913 14.5,8 C14.5,11.5898509 11.5898509,14.5 8,14.5 Z M7.1875,10.4375 L7.1875,12.0625 L8.8125,12.0625 L8.8125,10.4375 L7.1875,10.4375 Z M7.1875,4.75 L7.1875,9.625 L8.8125,9.625 L8.8125,4.75 L7.1875,4.75 Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ExclamationDisc;